<script>
    import CourseRange from './CourseRange.svelte';
    import { slide } from 'svelte/transition';

    export let courses;

    let key = 'all';

    function selectKey(k) {
        key = k;
    }

</script>

<div class='row'>
    <div class='col-md-2'>
        <div class='list-group'>
            <div class='list-group-item'>
                <span class='fas fa-info-circle'></span> Select a Filter
            </div>
            <div
                class='list-group-item js-button clearfix'
                on:click={() => selectKey('all')}
                on:keypress={() => selectKey('all')}
                class:active='{key == 'all'}'
                role='button'
                tabindex='0'
            >
                <span class='badge bg-info rounded shadow-sm float-end'>{ courses.all.count }</span>

                {#if key == 'all'}

                    <span class='fas fa-check-circle text-success me-2'></span>

                {/if}

                All Locations
            </div>

            {#if courses.cities.length > 0}

                {#each courses.cities as c}

                    <div
                        class='list-group-item js-button clearfix'
                        on:click={() => selectKey(c.key)}
                        on:keypress={() => selectKey(c.key)}
                        class:active='{key == c.key}'
                        role='button'
                        tabindex='0'
                    >
                        <span class='badge bg-info rounded shadow-sm float-end'>{ c.count }</span>

                        {#if key == c.key}

                            <span class='fas fa-check-circle text-success me-2'></span>

                        {/if}

                        { c.city }
                    </div>

                {/each}

            {/if}

        </div>

    </div>
    <div class='col-md-10'>

        {#if key == 'all'}

            <section in:slide class='mt-3'>
                <h2>
                    <span class='fas fa-map-marker'></span> All Locations
                </h2>

                <hr/>

                <CourseRange
                    range={courses.all.range}
                />
            </section>

        {/if}

        {#if courses.cities.length > 0}

            {#each courses.cities as c}

                {#if key == c.key}

                    <section in:slide class='mt-3'>
                        <h2>
                            <span class='fas fa-map-marker'></span> { c.city }
                        </h2>

                        <hr/>
    
                        <CourseRange
                            range={c.range}
                        />
                    </section>


                {/if}

            {/each}

        {/if}


    </div>
</div>